import React from "react";
import { Box, Stack } from "@mui/material";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import TopBar from "../../../../../../component/TopBar";
import EmployeeForm from "./OnboardingForm";
import InFlight from "./InFlight";
import { getActiveLegalUnit } from "../../../../../../services/globalData";
import { tokens, displayFont, radius } from "../../../../../../theme";

export default () => {
  const active = getActiveLegalUnit();

  return (
    <Box sx={{ width: "100%", paddingBlock: "1rem" }}>
      <TopBar
        MainHeading="Onboard employee"
        breadcrumbs={[{ label: "People", href: "/app/employees" }, { label: "Onboard" }]}
      />

      <Box sx={{ maxWidth: "56rem", mx: "auto" }}>
        {/* intro header */}
        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: "1.5rem" }}>
          <Box sx={{ width: "2.75rem", height: "2.75rem", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", background: `${tokens.accentTint}`, color: tokens.accent }}>
            <PersonAddAltOutlinedIcon />
          </Box>
          <Box>
            <Box sx={{ fontFamily: displayFont, fontSize: "1.25rem", fontWeight: 600, color: tokens.text, letterSpacing: "-0.01em" }}>
              Onboard a new employee
            </Box>
            <Box sx={{ fontSize: "0.875rem", color: tokens.textMuted }}>
              {active?.name ? <>Adding to <b style={{ color: tokens.text }}>{active.name}</b></> : "Fill in the details below"}
            </Box>
          </Box>
        </Stack>

        <Box sx={{ background: tokens.card, border: `1px solid ${tokens.border}`, borderRadius: `${radius.card}px`, p: "2rem" }}>
          <EmployeeForm />
        </Box>

        {/* Who is already part-way through, under the form for the next one.
            Adding a hire and chasing the last one are the same job. */}
        <InFlight />
      </Box>
    </Box>
  );
};
